import React from 'react';

import { QueryObserverResult, RefetchOptions, RefetchQueryFilters, UseQueryResult } from '@tanstack/react-query';

export type RefetchFn<T = any> = <TPageData>(
  options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
) => Promise<QueryObserverResult<T, unknown>>;

type AwaitQueryProps<T> = {
  queryResult: Pick<UseQueryResult<T>, 'data' | 'isLoading' | 'isFetching' | 'error' | 'isError' | 'refetch'>;
  // children: (data: T) => React.ReactNode;
  children: React.ReactNode;
  initialLoadingComponent?: React.ComponentType<any>;
  additionalLoadingComponent?: React.ComponentType<any>;
  errorComponent?: React.ComponentType<{ error: any; refetch: RefetchFn }>;
};

/**
 * LoadingHandler 컴포넌트: React Query의 초기 로딩과 추가 로딩을 구분하여 렌더링
 *
 * @param queryResult - React Query의 결과 객체
 * @param children - 성공 시 데이터를 렌더링하는 함수
 * @param initialLoadingComponent - 초기 로딩 중에 표시할 컴포넌트
 * @param additionalLoadingComponent - 추가 로딩 중에 표시할 컴포넌트
 * @param errorComponent - 에러 발생 시 표시할 컴포넌트
 */
function AwaitQuery<T>({
  queryResult,
  // children: ChildrenComponent,
  children,
  initialLoadingComponent: InitialLoadingComponent,
  additionalLoadingComponent: AdditionalLoadingComponent,
  errorComponent: ErrorComponent,
}: AwaitQueryProps<T>) {
  const { data, isLoading, isFetching, error, refetch, isError } = queryResult;

  if (isLoading) {
    return InitialLoadingComponent && <InitialLoadingComponent />;
  }
  if (isError) {
    return ErrorComponent && <ErrorComponent error={error} refetch={refetch} />;
  }

  return (
    <>
      {/* {!isLoading && ChildrenComponent(data!)} */}
      {!isLoading && children}
      {data && isFetching && !isLoading && AdditionalLoadingComponent && <AdditionalLoadingComponent />}
    </>
  );
}

export default AwaitQuery;
